<template>
	<!-- Footer -->
	<footer class="bg-light mt-auto thisfooter" >
		<!-- Copyright -->
		<div class="footer-copyright text-center py-3">
			&copy; Copyright <span id="copy_right_year"></span>
		</div>
		<!-- End copyright -->
	</footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'FooterItem',
    mounted() {
        const cyear = new Date().getFullYear();
        const el = document.querySelector('#copy_right_year');
        if (el) {
            el.innerHTML = cyear.toString();
        }
    }
})
</script>

<style>
    footer {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
</style>